const html = require('choo/html');
const uploadPassword = require('./uploadPassword');
const uploadSSN = require('./uploadSSN');

module.exports = function(state) {
  return html`
      <div class="mt-3">
        <div class="checkbox inline-block mr-3 px-1">
          <input
            id="add-password"
            type="checkbox"
            ${state.syndisInputs.useProtection ? 'checked' : ''}
            autocomplete="off"
            onchange="${toggleProtection}"
          />
          <label for="add-password">
            ${state.translate('protectWith')}
          </label>
        </div>
  
        <select 
          id="protection-type-select"  
          class="inline-block appearance-none bg-white border-[1px] border-gray-400 focus:border-blue-60 px-2 py-1 pr-8 rounded leading-tight dark:bg-grey-80
                  ${state.syndisInputs.useProtection ? '' : 'invisible'}"
          onchange="${switchProtectionType}"
        >
          <option value="pwd"
            "${state.syndisInputs.usePwd ? 'selected' : ''}"
          >
            ${state.translate('withPassword')}
          </option>

          <option value="ssn"
            "${state.syndisInputs.useSSN ? 'selected' : ''}"
          >
          ${state.translate('withSSN')}
          </option>
        </select>
  
        <div id="protection-type-container"
          class="${state.syndisInputs.useProtection ? '' : 'invisible'}"
        >
          <div id="password-container"
            class="${state.syndisInputs.usePwd ? '' : 'hidden'}"
          >
            ${uploadPassword(state)}
          </div>
  
          <div id="ssn-container"
            class="${state.syndisInputs.useSSN ? '' : 'hidden'}"
          >
            ${uploadSSN(state)}
          </div>
        </div>
      </div>
    `;

  function toggleProtection(event) {
    event.stopPropagation();
    const select = document.getElementById('protection-type-select');
    const typeContainer = document.getElementById('protection-type-container');

    if (event.target.checked) {
      state.syndisInputs.useProtection = true;
      select.classList.remove('invisible');
      typeContainer.classList.remove('invisible');
      select.focus();
    } else {
      state.syndisInputs.useProtection = false;
      select.classList.add('invisible');
      typeContainer.classList.add('invisible');
    }
    removeProtectionErrors();
  }

  function switchProtectionType(event) {
    event.stopPropagation();
    const type = event.target.value;

    const pwdContainer = document.getElementById('password-container');
    const ssnContainer = document.getElementById('ssn-container');

    if (type === 'ssn') {
      const ssnInput = document.getElementById('ssn-input');
      state.syndisInputs.useSSN = true;
      state.syndisInputs.usePwd = false;

      pwdContainer.classList.add('hidden');
      ssnContainer.classList.remove('hidden');
      ssnInput.focus();
    } else {
      const passwordInput = document.getElementById('password-input');
      state.syndisInputs.usePwd = true;
      state.syndisInputs.useSSN = false;

      ssnContainer.classList.add('hidden');
      pwdContainer.classList.remove('hidden');
      passwordInput.focus();
    }
    removeProtectionErrors();
  }

  function removeProtectionErrors() {
    state.syndisInputs.phoneError = false;
    state.syndisInputs.pwdError = false;
    state.syndisInputs.ssnError = false;
  }
};
